export class AOutDescription {
  number: number;
  description: string;
  department: string;

  constructor() {
    this.number = 0;
    this.description = "-- not in use --";
    this.department = "";
  }
}

export class AnalogOutDescription {
  AO: AOutDescription[];

  constructor() {
    this.AO = [];
  }
}
